var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(!this.connection)?[_c('h2',{staticClass:"title glowText"},[_vm._v("CONNECTING...")]),_c('button',{on:{"click":_vm.reloadPage}},[_vm._v("Retry")]),_c('button',{on:{"click":_vm.stop}},[_vm._v("Stop")])]:void 0],2)
}
var staticRenderFns = []

export { render, staticRenderFns }